import axios from 'axios';
import { getTokenCredentials } from '../../../Shared/functions';
import { BASE_API } from '../../../Shared/Constants';

export function getRules(body){
    return axios.post(BASE_API + 'api/role/getlist', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
    });
}

export function getRule(body) {
    return axios.post(BASE_API + 'api/role/getlist', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
    });
}

export function newRule(body) {
    return axios.post(BASE_API + 'api/role/register', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        // Devolver la respuesta del backend para que el formulario muestre el mensaje.
        return error.response || { status: 0, data: { error: -1, message: error.message } };
    });
}

export function updateRule(body) {
    return axios.post(BASE_API + 'api/role/register', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        return error.response || { status: 0, data: { error: -1, message: error.message } };
    });
}

export function updateStatus(body) {
    return axios.post(BASE_API + 'api/role/register', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
    });
}
    